// removed by extract-text-webpack-plugin
module.exports = {"relative":"G84889d","absolute":"G316e3b","fixed":"G3b7ead","centerCenter":"G9c2edb"};